import React from "react";
import ProgressBar from "../../../../custom_utilities/ProgressBar/ProgressBar";
import images from "../../../../utilities/images/images";
import "./EngageTodayGoal.css";

function EngageTodayGoal({
  goalSummary = "03/15 Q's",
  progressPercent = 0,
  pointsEarnedToday = 43,
  motivationMessage = "Keep the streak going. Finish today's goal.",
  onEditGoal,
}) {
  const clamped = Math.min(100, Math.max(0, Number(progressPercent) || 0));

  return (
    <section className="engage-today-goal" aria-labelledby="engage-today-goal-heading">
      <header className="engage-today-goal__header">
        <div className="engage-today-goal__header-text">
          <p className="engage-today-goal__label">Today&apos;s Goal</p>
          <h2 className="engage-today-goal__goal" id="engage-today-goal-heading">
            {goalSummary}
          </h2>
        </div>
        <button type="button" className="engage-today-goal__edit" onClick={onEditGoal}>
          <img
            src={images.engage_editgoal_icon}
            alt=""
            className="engage-today-goal__edit-icon"
            width={18}
            height={18}
            aria-hidden="true"
          />
          <span>Edit Goal</span>
        </button>
      </header>

      <div
        className="engage-today-goal__progress"
        role="group"
        aria-label="Today&apos;s goal progress"
      >
        <ProgressBar
          progress={clamped}
          height="12px"
          fillStyle={{
            background: "linear-gradient(90deg, #e52d27 0%, #f06529 100%)",
          }}
        />
      </div>

      <p className="engage-today-goal__points">
        Points Earned Today : {pointsEarnedToday}
      </p>

      <div className="engage-today-goal__badge">
        <img
          src={images.engage_storm_icon}
          alt=""
          className="engage-today-goal__storm-icon"
          width={18}
          height={18}
          aria-hidden="true"
        />
        <span className="engage-today-goal__badge-text">{motivationMessage}</span>
      </div>
    </section>
  );
}

export default EngageTodayGoal;
